import {Component} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {FilterOperator} from '@progress/kendo-data-query';
import {BaseGridFilterComponent, pickFilterOperators} from '@q9elements/ui-kit/components';

@Component({
  selector: 'app-code-search-text-filter',
  template: `
    <ng-container [formGroup]="filterForm">
      <q9-grid-filter-operator-select
        formControlName="operator"
        [operators]="operators"></q9-grid-filter-operator-select>

      <q9-text-field formControlName="value"></q9-text-field>
    </ng-container>
  `
})
export class CodeSearchTextFilterComponent extends BaseGridFilterComponent {
  operators = pickFilterOperators([
    FilterOperator.EqualTo,
    FilterOperator.NotEqualTo,
    FilterOperator.Contains
  ]);
  filterForm = new FormGroup({
    operator: new FormControl(FilterOperator.Contains),
    value: new FormControl('', {
      updateOn: this.popupService ? 'change' : 'blur'
    })
  });
}
